import "../../style/message/online_msg.scss";
import {Button, Form, FormControl, FormGroup, FormLabel} from "react-bootstrap";
import EventMsgSamplesModal from "../modal/EventMsgSamplesModal.tsx";
import Layout from "../layout/Layout.tsx";
import React, {ChangeEvent, useEffect, useRef, useState} from "react";
import {useLoading} from "../components/loading/LoadingProvider.tsx";
import {useNavigate} from "react-router-dom";
import {post} from "../utils/FetchUtil.ts";
import {isNotEmpty} from "../utils/CommonUtil.ts";

const OnlineMsgContentPage:React.FC = () => {
    const breadcrumbList = ["eGiftの注文", "オンラインメッセージの入力"];
    const { showLoading, hideLoading } = useLoading();
    const navigate = useNavigate();
    const [errorList, setErrorList] = useState([]);
    const [validated, setValidated] = useState(false);
    const msgContentRef = useRef(null);
    const [messageDto, setMessageDto] = useState<MessageInputDto>({
        content: '',
        sender_name: '',
        image_path: ''
    });
    const getOnlineMsgContent = () => {
        showLoading();
        post<MessageInputDto>({
            action: "/api/message/online/content",
            data: {},
        })
            .then((data) => {
                // @ts-ignore
                setMessageDto(data);
            })
            .catch((reason) => {
                // @ts-ignore
                setErrorList([reason.message]);
            })
            .finally(() => {
                hideLoading();
            });
    }
    useEffect(() => {
        getOnlineMsgContent();
    }, []);
    const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setMessageDto(prevState => ({...prevState, [name]: value}));
        if(name === "content"){
            const textarea = msgContentRef.current;
            if (textarea) {
                // @ts-ignore
                textarea.style.height = 'auto';
                // @ts-ignore
                const lineCount = (textarea.value.match(/\n/g) || []).length + 1;
                if (lineCount > 5) {
                    // @ts-ignore
                    textarea.style.height = `${textarea.scrollHeight}px`;
                } else {
                    // @ts-ignore
                    textarea.style.height = 'auto';
                }
            }
        }
    };
    const [showMsgTempModal, setShowMsgTempModal] = useState(false);
    const onSelectedMsgFromModal = ( msg: string ) => {
        setMessageDto(prevState => ({...prevState, ["content"]: msg}));
        setShowMsgTempModal(false);
    }
    const onClickNext = () => {
        setErrorList([]);
        let inputForm = document.getElementById("frmOnlineMsgContent");
        setValidated(true);
        // @ts-ignore
        if(inputForm.checkValidity()){
            setValidated(false);
            showLoading();
            post<MessageInputDto>({
                action: "/api/message/online/content/save",
                data: messageDto,
            })
                .then(() => {
                    navigate(`/message/online/commit/`);
                })
                .catch((reason) => {
                    // @ts-ignore
                    setErrorList([reason.message]);
                })
                .finally(() => {
                    hideLoading();
                });
        }

    }
    return (
        <Layout page_meta = {{title: 'オンラインメッセージ設定｜geeva'}}
                breadcrumb_list={breadcrumbList}
                error_list={errorList}
                hide_footer={true}
                page_class={"online-msg-page"}
        >
            <article className="page-content online-msg-page-content">
                <section>
                    <dl className="page-title">
                        <dt>オンラインメッセージの入力</dt>
                        <dd>
                            以下フォームに必要情報をご記入の上、<br/>
                            ページ下部の「<strong>次の画面へ</strong>」をクリックしてください。
                        </dd>
                    </dl>
                </section>
                <br/>
                <section>
                    <Form id="frmOnlineMsgContent" noValidate validated={validated}>
                        <FormGroup className="msg-input-group">
                            <FormLabel>メッセージ（全角500文字以内）<span className="length-counter">{messageDto.content.length}/500</span></FormLabel>
                            <FormControl as="textarea" required
                                         ref={msgContentRef}
                                         id="txtMessage"
                                         name="content"
                                         style={{ overflowY: 'hidden', resize: 'none' }}
                                         rows={5}
                                         placeholder=""
                                         maxLength={500}
                                         value={messageDto.content}
                                         onChange={handleInputChange}
                            ></FormControl>
                            <Form.Control.Feedback type="invalid">
                                メッセージを入力してください。
                            </Form.Control.Feedback>
                            <FormGroup>
                                <span className="btn-msg-samples" onClick={() => {setShowMsgTempModal(true)}}><span>テンプレート</span>　▶</span>
                            </FormGroup>
                        </FormGroup>
                        <br/>
                        <FormGroup className="msg-input-group">
                            <FormLabel>お名前（全角20文字以内）<span className="length-counter">{messageDto.sender_name.length}/20</span></FormLabel>
                            <FormControl type="text"
                                         name="sender_name"
                                         placeholder=""
                                         maxLength={20}
                                         value={messageDto.sender_name}
                                         onChange={handleInputChange}
                            ></FormControl>
                            <Form.Control.Feedback type="invalid">
                                お名前を入力してください。
                            </Form.Control.Feedback>
                        </FormGroup>
                    </Form>
                </section>
                <br/>
                <section className="main-buttons">
                    <Button variant="light" onClick={() => navigate('/message/online')}>戻　る</Button>
                    <Button variant="primary" onClick={onClickNext} disabled={isNotEmpty(errorList)}>次の画面</Button>
                </section>
                <br/><br/>
                <section>
                    <EventMsgSamplesModal genre="ems" show={showMsgTempModal} onClosed={() => {setShowMsgTempModal(false)}} onSelected={onSelectedMsgFromModal}></EventMsgSamplesModal>
                </section>
            </article>
        </Layout>
    );
};
export default OnlineMsgContentPage;